export const setStatus = (e: any) => ({
  type: 'APP_STATUS_CHANGE',
  payload: e,
});
